import { v4 as uuidv4 } from 'uuid';

export function deleteInActiveSubscriptions({ subscription }) {
    this.subscriptions = this.subscriptions.filter((item) => item.id !== subscription.id);
    this.observed.subscriptions = uuidv4();
}
